import * as React from "react";
import Service from "../common/Services/Service";

import storage from "../storage";

import makeStore from "./store";
import { StoreDefaultValues } from "./storeTypes";

function useStore() {
  const [isLoading, setIsLoading] = React.useState(true);
  const [defaultValues, setDefaultValues] =
    React.useState<StoreDefaultValues>();

  const [promise] = React.useState(async () => {
    // load default store values
    try {
      const preferences = await storage.getPreferences();
      const tokens = await storage.getAuthorization();

      setDefaultValues({
        ...preferences,
        tokens,
        isSetup: Service.isSetup(),
      });
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  });

  const store = React.useMemo(() => {
    if (!isLoading) {
      return makeStore(defaultValues);
    }
  }, [isLoading, defaultValues]);

  return {
    promise,
    isLoading,
    data: store,
  };
}

export default useStore;
